<nz-breadcrumb [nzAutoGenerate]="true">
    <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs; let last = last">
        <a *ngIf="!last" [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
          <span *ngIf="last">{{ breadcrumb.label }}</span>
    </nz-breadcrumb-item>
</nz-breadcrumb>